module.exports = __webpack_public_path__ + "static/img/ICON1@2x.09ca879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ICON1@2x.png
// module id = U7Bq
// module chunks = 1